import { CommonModule } from '@angular/common';
import {LiveAnnouncer} from '@angular/cdk/a11y';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {ChangeDetectionStrategy, ChangeDetectorRef, Component, computed, inject, Input, model, signal, ViewChild} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule,FormsModule } from '@angular/forms';
import {MatAutocompleteModule, MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {MatChipInputEvent, MatChipsModule} from '@angular/material/chips';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatIconModule} from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
@Component({
  selector: 'app-input-select-luogo-area',
  standalone: true,
  imports: [MatFormFieldModule, MatChipsModule, MatIconModule, MatAutocompleteModule, FormsModule,ReactiveFormsModule,MatInputModule,CommonModule,MatProgressSpinnerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './input-select-luogo-area.component.html',
  styleUrl: './input-select-luogo-area.component.css'
})
export class InputSelectLuogoAreaComponent {
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  readonly currentValue = model('');
  @ViewChild('luogoInput') luogoInput: any;
  @Input() datiSelezionati = signal<any>([]);
  @Input() datiIstatSelezionati = signal<number[] | string[]>([]);
  @Input() allData: any[] = [];
  @Input() allDataIstat:number[] | string[]= []
  @Input() deleghe=new Array()
  @Input() form!: FormGroup;
  @Input() name!: string;
  @Input() canAdd:boolean=true
  @Input() placeholder:string=''
  filteredDatiSelezionati = signal<any[]>([]);
  viewMatSpinner = false;
  readonly announcer = inject(LiveAnnouncer);

  constructor(     private fb: FormBuilder , private cdr : ChangeDetectorRef){}

  ngOnInit() {

    this.filtereddatiSelezionati();
   // this.form.controls[this.name].setValue(this.datiSelezionati())
  }
  sleep(seconds:number) {
    return new Promise(resolve => setTimeout(resolve, seconds * 100));
  }
  
  async filtereddatiSelezionati() {
    this.viewMatSpinner = true;
    const currentValue = this.currentValue().toUpperCase();
  
    // Usando un setTimeout simuliamo una funzione asincrona per il filtro
    const filteredData = await new Promise<any[]>((resolve) => {
      setTimeout(() => {
        if (currentValue) {
          resolve(this.allData.filter(dato => dato.denominazione.includes(currentValue)));
        } else {
          resolve(this.allData.slice());
        }
      }, 0); // Puoi regolare il timeout, qui 0 è solo un esempio per simulare asincronia
    });
  
    this.filteredDatiSelezionati.set(filteredData);
  
    // Ora che l'operazione di filtraggio è terminata, disabilitiamo lo spinner
    this.viewMatSpinner = false;
    this.cdr.detectChanges();
  }
  

  trackChatMessage(index: number, chatMessage: any) {
    return chatMessage.istat;
  }
  add(event: MatChipInputEvent): void {
    if(!this.canAdd){
      return
    }
    const value = (event.value || '').trim();

    if (value) {
      this.datiSelezionati.update(datiSelezionati => [...datiSelezionati, value]);
    }
    this.luogoInput.nativeElement.value = '';
    this.filteredDatiSelezionati.set(this.allData.slice());
   // this.currentValue.set('');
  }

  remove(datoSelezionato: string): void {
    this.datiSelezionati.update(datiSelezionati => {
      const index = datiSelezionati.indexOf(datoSelezionato);
      if (index < 0) {
        return datiSelezionati;
      }
  
      datiSelezionati.splice(index, 1);
  
      this.announcer.announce(`Removed ${datoSelezionato}`);
      return [...datiSelezionati];
    });
  
    const informationArray = this.controlss;
  
    if (this.controlss?.controls.length === 0) {
      // Aggiungo i due oggetti al FormArray information se è vuoto
      if (this.name === 'regioni') {
        informationArray.push(this.fb.group({
          key: ['istatRegione'],
          type: ['string'],
          value: [JSON.stringify(this.datiSelezionati().map((el: any) => el.id))],
          isArray: [true]
        }));
      }
      if (this.name === 'comuni') {
        informationArray.push(this.fb.group({
          key: ['istatComune'],
          type: ['string'],
          value: [JSON.stringify(this.datiSelezionati().map((el: any) => el.id))],
          isArray: [true]
        }));
      }
  
      this.form.setControl('information', informationArray);
  
    } else {
      let regioneFound = false;
      let comuneFound = false;
      let regioneDelegheFound = false;
      let comuneDelegheFound = false;
  
      // Aggiorno i dati esistenti in base alla chiave (istatRegione o istatComune)
      informationArray.controls.forEach((control: any) => {
        if (control.get('key')?.value === 'istatRegione' && this.name === 'regioni') {
          control.get('value')?.setValue(JSON.stringify(this.datiSelezionati().map((el: any) => el.id)));
          regioneFound = true;
        }
  
        if (control.get('key')?.value === 'istatComune' && this.name === 'comuni') {
          control.get('value')?.setValue(JSON.stringify(this.datiSelezionati().map((el: any) => el.id)));
          comuneFound = true;
        }
  
        // Rimozione logica per istatRegioneDeleghe
        if (control.get('key')?.value === 'istatRegioneDeleghe' && this.name === 'regioni') {
          const valoriAttuali = JSON.parse(control.get('value')?.value || '[]');
          const indexDeleghe = valoriAttuali.indexOf(datoSelezionato);
          if (indexDeleghe >= 0) {
            valoriAttuali.splice(indexDeleghe, 1);  // Rimuovi il dato selezionato
            control.get('value')?.setValue(JSON.stringify(valoriAttuali));
          }
          regioneDelegheFound = true;
        }
  
        // Rimozione logica per istatComuneDeleghe
        if (control.get('key')?.value === 'istatComuneDeleghe' && this.name === 'comuni') {
          const valoriAttuali = JSON.parse(control.get('value')?.value || '[]');
          const indexDeleghe = valoriAttuali.indexOf(datoSelezionato);
          if (indexDeleghe >= 0) {
            valoriAttuali.splice(indexDeleghe, 1);  // Rimuovi il dato selezionato
            control.get('value')?.setValue(JSON.stringify(valoriAttuali));
          }
          comuneDelegheFound = true;
        }
      });
  
      // Se non è stato trovato, aggiungo il nuovo gruppo per istatRegione o istatComune
      if (!regioneFound && this.name === 'regioni') {
        informationArray.push(this.fb.group({
          key: ['istatRegione'],
          type: ['string'],
          value: [JSON.stringify(this.datiSelezionati().map((el: any) => el.id))],
          isArray: [true]
        }));
      }
  
      if (!comuneFound && this.name === 'comuni') {
        informationArray.push(this.fb.group({
          key: ['istatComune'],
          type: ['string'],
          value: [JSON.stringify(this.datiSelezionati().map((el: any) => el.id))],
          isArray: [true]
        }));
      }
  
      // Se non esiste il gruppo, aggiungo un nuovo gruppo vuoto per istatRegioneDeleghe o istatComuneDeleghe
      if (!regioneDelegheFound && this.name === 'regioni') {
        informationArray.push(this.fb.group({
          key: ['istatRegioneDeleghe'],
          type: ['string'],
          value: [JSON.stringify([])],  // Inizialmente vuoto
          isArray: [true]
        }));
      }
  
      if (!comuneDelegheFound && this.name === 'comuni') {
        informationArray.push(this.fb.group({
          key: ['istatComuneDeleghe'],
          type: ['string'],
          value: [JSON.stringify([])],  // Inizialmente vuoto
          isArray: [true]
        }));
      }
  
      this.form.setControl('information', informationArray);
    }
  
    console.log(this.controlss?.controls);
  }
  

  async selected(event: MatAutocompleteSelectedEvent): Promise<void> {
    this.viewMatSpinner = true;
  
    await new Promise<void>((resolve) => {
      setTimeout(() => {
  
        // Controlla se il valore è già presente nei dati selezionati
        if (this.datiSelezionati().some((dato: any) => 
            dato.id === event.option.value.id && dato.denominazione === event.option.value.denominazione)) {
  
          this.luogoInput.nativeElement.value = '';
          this.filteredDatiSelezionati.set(this.allData.slice());
          event.option.deselect();
          resolve();
          return;
        }
  
        // Aggiungo solo il nuovo valore selezionato
        this.datiSelezionati.update(datiSelezionati => [...datiSelezionati, event.option.value]);
        const nuovoValore = event.option.value.id;  // Salvo il nuovo valore selezionato
  
        this.luogoInput.nativeElement.value = '';
        this.filteredDatiSelezionati.set(this.allData.slice());
        event.option.deselect();
  
        const informationArray = this.controlss;
  
        // Controllo la lunghezza di this.controlss?.controls
        if (this.controlss?.controls.length === 0) {
        
          // Aggiungo i due oggetti al FormArray information se è vuoto
          if (this.name === 'regioni') {
            informationArray.push(this.fb.group({
              key: ['istatRegione'],
              type: ['string'],
              value: [JSON.stringify(this.datiSelezionati().map((el: any) => el.id))],
              isArray: [true]
            }));
          }
          if (this.name === 'comuni') {
          
            informationArray.push(this.fb.group({
              key: ['istatComune'],
              type: ['string'],
              value: [JSON.stringify(this.datiSelezionati().map((el: any) => el.id))],
              isArray: [true]
            }));
          }
  
          // Aggiungo anche istatComuneDeleghe o istatRegioneDeleghe solo con il nuovo valore
          if (this.name === 'regioni') {
            informationArray.push(this.fb.group({
              key: ['istatRegioneDeleghe'],
              type: ['string'],
              value: [JSON.stringify([nuovoValore])],  // Solo il nuovo valore
              isArray: [true]
            }));
          }
          if (this.name === 'comuni') {
            informationArray.push(this.fb.group({
              key: ['istatComuneDeleghe'],
              type: ['string'],
              value: [JSON.stringify([nuovoValore])],  // Solo il nuovo valore
              isArray: [true]
            }));
          }
  
          this.form.setControl('information', informationArray);
  
        } else {
       
          // Aggiorno i dati esistenti in base alla chiave (istatRegione, istatComune, istatRegioneDeleghe, istatComuneDeleghe)
          let regioneFound = false;
          let comuneFound = false;
          let regioneDelegheFound = false;
          let comuneDelegheFound = false;
  
          informationArray.controls.forEach((control: any) => {
            if (control.get('key')?.value === 'istatRegione' && this.name === 'regioni') {
              control.get('value')?.setValue(JSON.stringify(this.datiSelezionati().map((el: any) => el.id)));
              regioneFound = true;
            }
            if (control.get('key')?.value === 'istatComune' && this.name === 'comuni') {
            
              control.get('value')?.setValue(JSON.stringify(this.datiSelezionati().map((el: any) => el.id)));
              comuneFound = true;
            }
  
            // Aggiorno solo con il nuovo valore per istatRegioneDeleghe o istatComuneDeleghe
            if (control.get('key')?.value === 'istatRegioneDeleghe' && this.name === 'regioni') {
              const valoriAttuali = JSON.parse(control.get('value')?.value || '[]');
              if (!valoriAttuali.includes(nuovoValore)) {
                valoriAttuali.push(nuovoValore);
                control.get('value')?.setValue(JSON.stringify(valoriAttuali));
              }
              regioneDelegheFound = true;
            }
  
            if (control.get('key')?.value === 'istatComuneDeleghe' && this.name === 'comuni') {
              const valoriAttuali = JSON.parse(control.get('value')?.value || '[]');
              if (!valoriAttuali.includes(nuovoValore)) {
                valoriAttuali.push(nuovoValore);
                control.get('value')?.setValue(JSON.stringify(valoriAttuali));
              }
              comuneDelegheFound = true;
            }
          });
  
          // Se non esiste già, aggiungo il nuovo gruppo per istatRegioneDeleghe o istatComuneDeleghe
          if (!regioneDelegheFound && this.name === 'regioni') {
            informationArray.push(this.fb.group({
              key: ['istatRegioneDeleghe'],
              type: ['string'],
              value: [JSON.stringify([nuovoValore])],  // Solo il nuovo valore
              isArray: [true]
            }));
          }
  
          if (!comuneDelegheFound && this.name === 'comuni') {
            informationArray.push(this.fb.group({
              key: ['istatComuneDeleghe'],
              type: ['string'],
              value: [JSON.stringify([nuovoValore])],  // Solo il nuovo valore
              isArray: [true]
            }));
          }
            // Se non esiste già, aggiungo il nuovo gruppo per istatRegioneDeleghe o istatComuneDeleghe
            if (!regioneFound && this.name === 'regioni') {
              informationArray.push(this.fb.group({
                key: ['istatRegione'],
                type: ['string'],
                value: [JSON.stringify([nuovoValore])],  // Solo il nuovo valore
                isArray: [true]
              }));
            }
    
            if (!comuneFound && this.name === 'comuni') {
              informationArray.push(this.fb.group({
                key: ['istatComune'],
                type: ['string'],
                value: [JSON.stringify([nuovoValore])],  // Solo il nuovo valore
                isArray: [true]
              }));
            }
          this.form.setControl('information', informationArray);
        }
  
        resolve();
      }, 0);
    });
  
    this.viewMatSpinner = false;
    this.cdr.detectChanges();
  }
  
  get controlss():FormArray{
    return this.form.controls["information"] as FormArray
  }

}
